import DateTimeUtil from "core/util/DateTimeUtil";
import { ContentBlock, ContentState } from "draft-js";

export default class LabelUtil {

	public static getVariableRegex(variables: string[] = []) {
		return new RegExp("\\$\\{" + (variables.length > 1 ? `(?:${variables.join('|')})` : variables[0]) + "\\}", 'gi');
	}

	public static getVariableStrategy(variables: string[]) {
		const rx = this.getVariableRegex(variables);
		return (contentBlock: ContentBlock, callback: any, contentState: ContentState) => {
			const text = contentBlock.getText();
			let matchArr: RegExpExecArray;
			let start: number;

			// tslint:disable-next-line
			while ((matchArr = rx.exec(text)) !== null) {
				start = matchArr.index;
				callback(start, start + matchArr[0].length);
			}
		};
	}

	public static formatTemplate(
		message: string,
		args: {
			[key: string]: null | undefined | string | number | Date
		},
		language: string = 'en'
	) {

		// if no arg data, return as-is
		if (!args || Object.keys(args).length < 1) {
			return message;
		}

		// match arg format, replace with variable values
		const rx = this.getVariableRegex(Object.keys(args));

		return message.replace(rx, (match): string => {

			const val = args[match.slice(2, match.length - 1)];

			// blank
			if (val === null || typeof val === 'undefined') {
				return '';
			}

			if (typeof val === 'number') {
				return (val).toString();
			}

			// localized date string
			if (val instanceof Date) {
				return DateTimeUtil.formatDate(val, language);
			}

			// plain string
			return (val || '').toString() || "";
		});
	}
}



// WEBPACK FOOTER //
// ./src/core/components/label/LabelUtil.ts